module.exports = __webpack_public_path__ + "img/other.01680f06.png";